"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(require("react-dom"));
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = __importDefault(require("../Map/context"));
var context_2 = __importDefault(require("./context"));
var hooks_1 = __importDefault(require("./hooks"));
var toElement = function (html, tagName) {
    if (tagName === void 0) { tagName = "div"; }
    var element = document.createElement(tagName);
    element.innerHTML = html;
    return element;
};
var CustomOverlay = function (props) {
    var map = React.useContext(context_1.default).map;
    var _a = React.useMemo(function () {
        var contentEl = typeof props.content === "string" ? toElement(props.content, "div") : props.content;
        var position = new kakao.maps.LatLng(props.position.lat, props.position.lng);
        var options = {
            map: map,
            position: position,
            content: contentEl,
            xAnchor: props.xAnchor,
            yAnchor: props.yAnchor,
            clickable: props.clickable,
        };
        return [new kakao.maps.CustomOverlay(options), contentEl];
    }, [props.content]), customOverlay = _a[0], content = _a[1];
    hooks_1.default.useInit(customOverlay);
    hooks_1.default.useRange(customOverlay, props.range);
    hooks_1.default.useZIndex(customOverlay, props.zIndex);
    hooks_1.default.usePosition(customOverlay, props.position);
    hooks_1.default.useAltitude(customOverlay, props.altitude);
    return (React.createElement(context_2.default.Provider, { value: { customOverlay: customOverlay } }, react_dom_1.default.createPortal(props.children, content)));
};
CustomOverlay.defaultProps = {
    clickable: true,
    xAnchor: 0.5,
    yAnchor: 0.5,
    zIndex: 0,
    range: 500,
    altitude: 2,
};
CustomOverlay.propTypes = {
    /** 맵에 표시될 좌표 */
    position: prop_types_1.default.shape({
        lat: prop_types_1.default.number.isRequired,
        lng: prop_types_1.default.number.isRequired,
    }).isRequired,
    /** 컨텐츠의 x축 위치 ( 0 ~ 1 ) */
    xAnchor: prop_types_1.default.number,
    /** 컨텐츠의 y축 위치 ( 0 ~ 1 ) */
    yAnchor: prop_types_1.default.number,
    /** 클릭 가능 여부 */
    clickable: prop_types_1.default.bool,
    /** z-index 속성 값 */
    zIndex: prop_types_1.default.number,
    /** 표시될 최대 거리 ( 로드맵 only ) */
    range: prop_types_1.default.number,
    /** 고도 ( 로드맵 only ) */
    altitude: prop_types_1.default.number,
};
exports.default = CustomOverlay;
